import gsap from 'gsap'
import SmoothScroll from '../utils/SmoothScroll'

const STORAGE_KEY = 'ab_popup_seen'
const ONE_DAY_MS = 24 * 60 * 60 * 1000

export default class Popup {
	constructor() {
		this.container = document.querySelector('[data-popup]')
		if (!this.container) return

		this.button = this.container.querySelector('button')
		this.smoothScroll = new SmoothScroll()
		this.onConfirm = this.#onConfirm.bind(this)
		this.onKeydown = this.#onKeydown.bind(this)

		if (this.#hasBeenSeenToday()) {
			this.container.remove()
			return
		}

		this.#show()
	}

	#hasBeenSeenToday() {
		try {
			const stored = localStorage.getItem(STORAGE_KEY)
			if (!stored) return false
			return Date.now() - parseInt(stored, 10) < ONE_DAY_MS
		} catch {
			return false
		}
	}

	#markSeen() {
		try {
			localStorage.setItem(STORAGE_KEY, Date.now().toString())
		} catch {}
	}

	#lockScroll() {
		this.smoothScroll.lenis?.stop()
	}

	#unlockScroll() {
		this.smoothScroll.lenis?.start()
	}

	#show() {
		this.#lockScroll()
		gsap.set(this.container, { opacity: 1, pointerEvents: 'auto', ease: 'power3.out' })
		this.button?.addEventListener('click', this.onConfirm)
		document.addEventListener('keydown', this.onKeydown)
	}

	#onKeydown(e) {
		if (e.key === 'Escape') this.#onConfirm()
	}

	#onConfirm() {
		this.#markSeen()
		this.button?.removeEventListener('click', this.onConfirm)
		document.removeEventListener('keydown', this.onKeydown)

		gsap.to(this.container, {
			opacity: 0,
			duration: 0.9,
			ease: 'power3.inOut',
			onComplete: () => {
				this.#unlockScroll()
				this.container?.remove()
			},
		})
	}

	destroy() {
		this.button?.removeEventListener('click', this.onConfirm)
		document.removeEventListener('keydown', this.onKeydown)
		this.#unlockScroll()
	}
}
